import { baseAPI } from 'api/baseApi'
import { ApiResponce } from 'types'
import { baseTransformResponse } from 'api/secondApi'
import {
 TCreditPaymentDetails,
 TCreditPlans,
 TCreditPurchase,
 TCreditPurchaseHistory,
 TCreditType,
 TMyProfileForm,
 TPaymentStatus,
} from '../types'

export const profileAPI = baseAPI.injectEndpoints({
 endpoints: ({ query, mutation }) => ({
  userProfileUpdate: mutation<void, TMyProfileForm>({
   query: (body) => ({
    method: 'post',
    url: 'user/user-profile-update',
    body,
   }),
   transformResponse: baseTransformResponse,
  }),
  getCreditPlan: query<TCreditPlans[], { credit_type: TCreditType }>({
   query: ({ credit_type }) => ({
    method: 'get',
    url: `user/credit-plans?credit_type=${credit_type}`,
   }),
   transformResponse: (resp: ApiResponce) => resp.data,
  }),
  getCreditPurchase: query<TCreditPurchase, { credit_type: TCreditType }>({
   query: (body) => ({
    method: 'post',
    url: 'user/credit-purchases',
    body,
   }),
   transformResponse: (resp: ApiResponce) => resp.data,
  }),
  getCreditHistory: query<
   TCreditPurchaseHistory[],
   { credit_type: TCreditType }
  >({
   query: (body) => ({
    method: 'post',
    url: 'user/credit-usage-history',
    body,
   }),
   transformResponse: (resp: ApiResponce) => resp.data,
  }),
  createPaymentIntent: mutation<TCreditPaymentDetails, { plan_id: any }>({
   query: (body) => ({
    method: 'post',
    url: 'user/payment-intent',
    body,
   }),
   transformResponse: (resp: ApiResponce) => resp.data,
  }),
  confirmPaymentSuccess: mutation<
   ApiResponce<void>,
   { payment_intent_id: string; plan_id: any }
  >({
   query: (body) => ({
    method: 'post',
    url: 'user/purchase-credit-plan',
    body,
   }),
   transformResponse: (resp: ApiResponce) => resp,
  }),
 }),
})

export const {
 useUserProfileUpdateMutation,
 useGetCreditPlanQuery,
 useGetCreditPurchaseQuery,
 useGetCreditHistoryQuery,
 useCreatePaymentIntentMutation,
 useConfirmPaymentSuccessMutation,
} = profileAPI
